module.exports = __webpack_public_path__ + "static/media/21899542850_0c540937e9_o (1).4229b638.jpg";